// extracted by mini-css-extract-plugin
export default {"actionBtn":"Update_actionBtn__S7H4P","confirm":"Update_confirm__KfN-F","reject":"Update_reject__xhUkQ","buttonContainer":"Update_buttonContainer__98nHR"};